import { router } from '@/main';

export const englishValidationsDictionary = {
  name: 'en',
  messages: {
    required: () => router.app.$t('validation.required'),
    min: (_: any, args: number) => router.app.$t('validation.min-length', { args }),
    max: (_: any, args: number) => router.app.$t('validation.max-length', { args }),
    between: (_: any, args: [number, number]) =>
      router.app.$t('validation.between', { minValue: args[0], maxValue: args[1] }),
    maxTagName: (_: any, args: number) => router.app.$t('validation.max-tag-name', { args }),
    notPastDate: (_: any) => router.app.$t('validation.not-past-date'),
    numeric: (_: any) => router.app.$t('validation.numeric'),
    ext: (_: any) => router.app.$t('validation.ext'),
    email: (_: any) => router.app.$t('validation.email'),
  },
};
